import Swiper from "./swiper";
import "jquery-ui/ui/widgets/datepicker.js";

// 메인 슬라이드
var mainSlide = new Swiper(".img_slide_box", {
    loop: true,
    autoplay: {
        delay: 4500,
        disableOnInteraction: false
    }
});

// 비회원 검사, 메인 롤링, 데이터피커
$(function() {
    if (location.hash == "#guest") {
        introModal.classList.add("active");
    } else if (location.hash == "#diagnosis") {
        var offset =
            parseInt($(".rolling-content").offset().top) -
            parseInt($(".nav-container")[0].offsetHeight);
        $("html, body").animate({ scrollTop: offset }, 400);
        // startClick();
    } else if (location.hash == "#precedent") {
        var offset =
            parseInt($(".main_precedent_container").offset().top) -
            parseInt($(".nav-container")[0].offsetHeight);
        $("html, body").animate({ scrollTop: offset }, 400);
    } else if (location.hash == "#review") {
        var offset =
            parseInt($(".user_review_section").offset().top) -
            parseInt($(".nav-container")[0].offsetHeight);
        $("html, body").animate({ scrollTop: offset }, 400);
    }
    history.replaceState(null, null, "/");

    window.addEventListener("hashchange", function() {
        if (location.hash == "#diagnosis") {
            var offset =
                parseInt($(".rolling-content").offset().top) -
                parseInt($(".nav-container")[0].offsetHeight);
            $("html, body").animate({ scrollTop: offset }, 400);
            $(".lnb-box")
                .removeClass("active")
                .css("display", "none");
            // startClick();
        } else if (location.hash == "#precedent") {
            var offset =
                parseInt($(".main_precedent_container").offset().top) -
                parseInt($(".nav-container")[0].offsetHeight);
            $("html, body").animate({ scrollTop: offset }, 400);
            $(".lnb-box")
                .removeClass("active")
                .css("display", "none");
        } else if (location.hash == "#review") {
            var offset =
                parseInt($(".user_review_section").offset().top) -
                parseInt($(".nav-container")[0].offsetHeight);
            $("html, body").animate({ scrollTop: offset }, 400);
            $(".lnb-box")
                .removeClass("active")
                .css("display", "none");
        }
        history.replaceState(null, null, "/");
    });

    $("#datepicker").datepicker({
        dateFormat: "yy-mm-dd", //Input Display Format 변경
        showOtherMonths: true, //빈 공간에 현재월의 앞뒤월의 날짜를 표시
        showMonthAfterYear: true, //년도 먼저 나오고, 뒤에 월 표시
        // ,changeYear: true //콤보박스에서 년 선택 가능
        // ,changeMonth: true //콤보박스에서 월 선택 가능
        // ,showOn: "both" //button:버튼을 표시하고,버튼을 눌러야만 달력 표시 ^ both:버튼을 표시하고,버튼을 누르거나 input을 클릭하면 달력 표시
        // ,buttonImage: "http://jqueryui.com/resources/demos/datepicker/images/calendar.gif" //버튼 이미지 경로
        buttonImageOnly: true, //기본 버튼의 회색 부분을 없애고, 이미지만 보이게 함
        buttonText: "선택", //버튼에 마우스 갖다 댔을 때 표시되는 텍스트
        yearSuffix: ".", //달력의 년도 부분 뒤에 붙는 텍스트
        monthNamesShort: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12"
        ], //달력의 월 부분 텍스트
        monthNames: [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12"
        ], //달력의 월 부분 Tooltip 텍스트
        dayNamesMin: ["일", "월", "화", "수", "목", "금", "토"], //달력의 요일 부분 텍스트
        dayNames: [
            "일요일",
            "월요일",
            "화요일",
            "수요일",
            "목요일",
            "금요일",
            "토요일"
        ] //달력의 요일 부분 Tooltip 텍스트
        // ,minDate: "-1M" //최소 선택일자(-1D:하루전, -1M:한달전, -1Y:일년전)
        // ,maxDate: "+1M" //최대 선택일자(+1D:하루후, -1M:한달후, -1Y:일년후)
    });
});

let drunkSlideNum = 0;

let pornoSlideNum = 0;
let pornoSlideNumLast = [0];

let divorceSlideNum = 0;
let divorceSlideNumLast = [0];


// 음주운전 swiper
var swiper = new Swiper(".swiper-container2", {
    autoHeight: true, //enable auto height
    pagination: {
        el: ".swiper-pagination"
    },
    touchRatio: 0,
    // autoplay: {
    //   delay: 1000,
    // },
    navigation: {
        // nextEl: ".popup-right , .modal1-ok",
        prevEl: ".popup-left"
    },
    on: {
        slideChangeTransitionEnd: function() {
            // console.log(this.activeIndex);
            for (var i = 0; i < drunkSlide.length; i++) {
                drunkSlide[i].style.visibility = "hidden";
            }
            drunkSlide[this.activeIndex].style.visibility = "visible";
            $(".drunk .modal1").scrollTop(0);
            if (drunkSlideNum === 6) return;
            drunkSlideNum = this.activeIndex;
        }
    }
});
// 음란물 swiper
var swiper2 = new Swiper(".swiper-container3", {
    autoHeight: true, //enable auto height
    pagination: {
        el: ".swiper-pagination2"
    },
    touchRatio: 0,
    // navigation: {
    //     nextEl: ".popup-right2",
    //     prevEl: ".popup-left2"
    // },
    on: {
        slideChangeTransitionEnd: function() {
            // console.log(this.activeIndex);
            for (var i = 0; i < pornoSlide.length; i++) {
                pornoSlide[i].style.visibility = "hidden";
            }
            pornoSlide[this.activeIndex].style.visibility = "visible";
            $(".porno .modal1").scrollTop(0);
            pornoSlideNum = this.activeIndex;
            this.activeIndex !== 0 &&
                pornoSlideNumLast[pornoSlideNumLast.length - 1] !==
                    this.activeIndex &&
                pornoSlideNumLast.push(this.activeIndex);
            // console.log(pornoSlideNumLast);
        }
    }
});
// 이혼 swiper
var swiper3 = new Swiper(".swiper-container4", {
    autoHeight: true, //enable auto height
    pagination: {
        el: ".swiper-pagination2"
    },
    touchRatio: 0,
    // navigation: {
    //     nextEl: ".popup-right2",
    //     prevEl: ".popup-left2"
    // },
    on: {
        slideChangeTransitionEnd: function() {
            // console.log(this.activeIndex);
            for (var i = 0; i < divorceSlide.length; i++) {
                divorceSlide[i].style.visibility = "hidden";
            }
            divorceSlide[this.activeIndex].style.visibility = "visible";
            $(".divorce .modal1").scrollTop(0);
            divorceSlideNum = this.activeIndex;
            this.activeIndex !== 0 &&
                divorceSlideNumLast[divorceSlideNumLast.length - 1] !==
                    this.activeIndex &&
                divorceSlideNumLast.push(this.activeIndex);
            // console.log(divorceSlideNumLast);
        }
    }
});


// 모달 인트로
const introModal = document.querySelector(".intro_popup");
const introClose = document.querySelector(".intro_popup .close");
const introBack = document.querySelector(".intro_popup .back");

// 모달 버튼
const divorceButton = document.querySelector(".intro_popup .divorce");
const drunkButton = document.querySelector(".intro_popup .drunk");
const pornoButton = document.querySelector(".intro_popup .porno");

const popupModalLinkBox = document.querySelector(".rolling-content .link-box");
const popupModalOpen = document.querySelector(".popup-modal-open");

// 음주
const popupModalDrunk = document.querySelector(".popup-modal.drunk");
const popupDrunkClose = document.querySelectorAll(".popup-modal.drunk .close");
const drunkModal1 = document.querySelector(".popup-modal.drunk .modal1");
const drunkModal2 = document.querySelector(".popup-modal.drunk .modal2");
const drunkSlide = document.querySelectorAll(".popup-modal.drunk .swiper-slide");
const drunkCurtain = document.querySelector(".popup-modal.drunk .curtain");
// 음란물
const popupModalPorno = document.querySelector(".popup-modal.porno");
const popupPornoClose = document.querySelectorAll(".popup-modal.porno .close");
const pornoModal1 = document.querySelector(".popup-modal.porno .modal1");
const pornoModal2 = document.querySelector(".popup-modal.porno .modal2");
const pornoSlide = document.querySelectorAll(".popup-modal.porno .swiper-slide");
const pornoCurtain = document.querySelector(".popup-modal.porno .curtain");
// 이혼
const popupModalDivorce = document.querySelector(".popup-modal.divorce");
const popupDivorceClose = document.querySelectorAll(".popup-modal.divorce .close");
const divorceModal1 = document.querySelector(".popup-modal.divorce .modal1");
const divorceModal2 = document.querySelector(".popup-modal.divorce .modal2");
const divorceSlide = document.querySelectorAll(".popup-modal.divorce .swiper-slide");
const divorceCurtain = document.querySelector(".popup-modal.divorce .curtain");
// Money
const popupModalMoney = document.querySelector(".popup-modal.money");
const popupMoneyClose = document.querySelectorAll(".popup-modal.money .close");
const popupMoneySubmit = document.querySelectorAll(".popup-modal.money .submit");


//결제
function pay(order_number, num, type) {
    let code;
    if (document.querySelector(".radio_box")) {
        if (type === "drunk") {
            code = document.querySelector(
                'input[name="drunk_pay_type"]:checked'
            ).value;
        } else if (type === "porno") {
            code = document.querySelector(
                'input[name="porno_pay_type"]:checked'
            ).value;
        } else if (type === "divorce") {
            code = document.querySelector(
                'input[name="divorce_pay_type"]:checked'
            ).value;
        }
    } else {
        code = "card";
    }

    // console.log(code);
    var IMP = window.IMP;
    IMP.init("imp81737258");
    IMP.request_pay(
        {
            pg: "kcp",
            pay_method: code,
            //merchant_uid : 'merchant_' + new Date().getTime(),
            merchant_uid: order_number,
            name: "얼마나와",
            amount: num,
            buyer_email: $("#user_email").val(),
            buyer_name: $("#user_name").val(),
            m_redirect_url:location.origin +"/api/diagnosis/update?imp_uid={imp_uid}&merchant_uid=" +order_number +"&pay_channel=mobile"
            //buyer_tel : '010-1234-5678',
            //buyer_addr : '서울특별시 강남구 삼성동',
            //buyer_postcode : '123-456'
        },
        function(rsp) {
            if (rsp.success) {
                var $url = "./api/diagnosis/update?imp_uid=" +rsp.imp_uid +"&merchant_uid=" + rsp.merchant_uid +"&pay_channel=pc";

                $.ajax({
                    url: $url,
                    type: "GET",
                    processData: false,
                    contentType: false,
                    cache: false,
                    success: function(data) {
                        var $data = JSON.parse(data);
                        if ($data["state"] == "end") {

                            // 로딩 
                            var loader = document.querySelector(".loader-modal");
                            loader.style.display = "flex";
            
                            setTimeout(() => {
                                loader.style.display = "none";
                                location.href = "/result/" + $data["msg"] + "?payment=y";

                                // 완료팝업 
                                // var finishModal = document.querySelector(".finish-modal");
                                // finishModal.style.display = "flex";
                            }, 3000);

                        } else {
                            alert($data["msg"]);
                        }
                    }
                });

                /*
          var msg = '결제가 완료되었습니다.';
          msg += '고유ID : ' + rsp.imp_uid;
          msg += '상점 거래ID : ' + rsp.merchant_uid;
          msg += '결제 금액 : ' + rsp.paid_amount;
          msg += '카드 승인번호 : ' + rsp.apply_num;
        */
            } else {
                var msg = "결제에 실패하였습니다.";
                msg += "에러내용 : " + rsp.error_msg;
                alert(msg);
            }
        }
    );
}

// 홈 음주운전 판례 자세히 보기
// class popupCustom {
//   constructor(btn , modal , close) {
//     this.btn = btn;
//     this.modal = modal;
//     this.close = close
//   }
//   modalEvent() {
//     this.btn.forEach( (e) => {

//       e.addEventListener('click' , () =>  {
//         this.modal.style.display = 'flex'
//       })
//     })
//     this.close.addEventListener('click' , () => this.modal.style.display = 'none')
//   }

// }

// const precedentPopup = new popupCustom(
//   document.querySelectorAll('.main-precedent-container .txt6 button') ,
//   document.querySelector('.main-precedent-popup'),
//   document.querySelector('.popup-close-btn-box button')
// )

// precedentPopup.modalEvent()

// 커스텀 셀렉트 박스 custom select-box

function customSelect() {
    var x, i, j, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("custom_select");
    for (i = 0; i < x.length; i++) {
        selElmnt = x[i].getElementsByTagName("select")[0];
        
        
        /*for each element, create a new DIV that will act as the selected item:*/
        a = document.createElement("DIV");
        a.setAttribute("class", "select-selected");
        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
        x[i].appendChild(a);
        /*for each element, create a new DIV that will contain the option list:*/
        b = document.createElement("DIV");
        b.setAttribute("class", "select-items select-hide");
        for (j = 1; j < selElmnt.length; j++) {
            /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
            c = document.createElement("DIV");
            c.innerHTML = selElmnt.options[j].innerHTML;
            c.addEventListener("click", function(e) {
                /*when an item is clicked, update the original select box,
        and the selected item:*/
                // console.log(selElmnt[j])
                
                var y, k, s, h;
                s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                h = this.parentNode.previousSibling;
                // console.log(s)
                if (s.id === 'same_record') {
                  document.querySelector("#same_record_2years").value = "";
                  document.querySelector("#same_record_release_3years").value ="";
                  document.querySelector("#is_same_suspended").value = "";
                  document.querySelector("#same_record_2years").nextSibling.innerHTML = ''
                  document.querySelector("#same_record_release_3years").nextSibling.innerHTML = ''
                  document.querySelector("#is_same_suspended").nextSibling.innerHTML = ''
                }
                if (s.id === 'other_record') {
                  document.querySelector("#is_other_suspended").value = "";
                  document.querySelector("#is_other_suspended").nextSibling.innerHTML = ''
                }
                if (s.id === 'is_bi_agreement') {
                  document.querySelector("#is_bi_agreement2").value = "";
                  document.querySelector("#is_bi_agreement2").nextSibling.innerHTML = ''
                }
                if (s.id === 'is_pi_agreement') {
                  document.querySelector("#is_pi_agreement2").value = "";
                  document.querySelector("#is_pi_agreement2").nextSibling.innerHTML = ''
                }
                var i
                for (i = 0; i < s.length; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                        s.selectedIndex = i;
                        h.innerHTML = this.innerHTML;
                        y = this.parentNode.getElementsByClassName("same-as-selected");
                        for (k = 0; k < y.length; k++) {
                            y[k].removeAttribute("class");
                        }
                        this.setAttribute("class", "same-as-selected");
                        break;
                    }
                }
                h.click();
            });
            b.appendChild(c);
        }
        x[i].appendChild(b);
        a.addEventListener("click", function(e) {
            /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
            e.stopPropagation();
            closeAllSelect(this);
            this.nextSibling.classList.toggle("select-hide");
            this.classList.toggle("select-arrow-active");
            if (measure.value === "측정하였음") {
                bac.style.display = "block";
                bacResult.style.display = "flex";
            } else {
                bac.style.display = "none";
                bac.value = "";
                bacResult.style.display = "none";
            }

            if (porno_married.value === "네. 기혼입니다.") {
                porno_children.style.display = "block";
                porno_parents.style.display = "none";
            } else if (porno_married.value === "아니오. 미혼입니다.") {
                porno_children.style.display = "none";
                porno_parents.style.display = "block";
            } else {
                porno_children.style.display = "none";
                porno_parents.style.display = "none";
            }
            
            if (divorce_child.value === "유") {
                divorce_children.style.display = "block";
                divorce_parents.style.display = "block";
            } else {
                divorce_children.style.display = "none";
                divorce_parents.style.display = "none";
            }

            if (divorce_reason.value === "본인" || divorce_reason.value === "상대방") {
                divorce_check.style.display = "block";
            } else {
                divorce_check.style.display = "none";
            }


            // if (divorce_married.value === "네. 기혼입니다.") {
            //     divorce_children.style.display = "block";
            //     divorce_parents.style.display = "none";
            // } else if (divorce_married.value === "아니오. 미혼입니다.") {
            //     divorce_children.style.display = "none";
            //     divorce_parents.style.display = "block";
            // } else {
            //     divorce_children.style.display = "none";
            //     divorce_parents.style.display = "none";
            // }

            if (same_record.value >= 1) {
                same_record_2years.style.display = "block";
                same_record_release_3years.style.display = "block";
                is_same_suspended.style.display = "block";
                same_record_2years_result.style.display = "flex";
                same_record_release_3years_result.style.display = "flex";
                is_same_suspended_result.style.display = "flex";
                // document.querySelector("#same_record_2years").value = "";
                // document.querySelector("#same_record_release_3years").value ="";
                // document.querySelector("#is_same_suspended").value = "";
            } else {
                same_record_2years.style.display = "none";
                same_record_release_3years.style.display = "none";
                is_same_suspended.style.display = "none";
                same_record_2years_result.style.display = "none";
                same_record_release_3years_result.style.display = "none";
                is_same_suspended_result.style.display = "none";
                // document.querySelector("#same_record_2years").value = "";
                // document.querySelector("#same_record_release_3years").value ="";
                // document.querySelector("#is_same_suspended").value = "";
            }

            if (other_record.value === "O") {
                is_other_suspended.style.display = "block";
                is_other_suspended_result.style.display = "flex";
            } else {
                is_other_suspended.style.display = "none";
                // document.querySelector("#is_other_suspended").value = "";
                is_other_suspended_result.style.display = "none";
            }

            if (is_bi_agreement.value === "O") {
                is_bi_agreement2.style.display = "block";
                is_bi_agreement_result.style.display = "flex";
            } else {
                is_bi_agreement2.style.display = "none";
                is_bi_agreement_result.style.display = "none";
                // document.querySelector("#is_bi_agreement2").value = "";
            }

            if (is_pi_agreement.value === "O") {
                is_pi_agreement2.style.display = "block";
                is_pi_agreement_result.style.display = "flex";
            } else {
                is_pi_agreement2.style.display = "none";
                is_pi_agreement_result.style.display = "none";
                // document.querySelector("#is_pi_agreement2").value = "";
            }
            swiper.update();
            swiper2.update();
            swiper3.update();
        });
    }
    function closeAllSelect(elmnt) {
        /*a function that will close all select boxes in the document,
  except the current select box:*/
        var x,y,i,arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected");
        for (i = 0; i < y.length; i++) {
            if (elmnt == y[i]) {
                arrNo.push(i);
            } else {
                y[i].classList.remove("select-arrow-active");
            }
        }
        for (i = 0; i < x.length; i++) {
            if (arrNo.indexOf(i)) {
                x[i].classList.add("select-hide");
            }
        }
    }
    /*if the user clicks anywhere outside the select box,
then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
}


